import * as breakpoints from "../../breakpoints";
import * as colors from "../../constants/colors";
import * as languages from "../../constants/languages";
import browserHistory from "react-router/lib/browserHistory";
import { css, StyleSheet } from "aphrodite";
import { english, spanish } from "../../constants/strings";
import { getClass } from "../../api/class";
import { handleUnknownError } from "../../lib/errorHandler";
import { Column, Row, Container } from "../../grid";
import FooterRow from "../FooterRow";
import { rootUrl } from "../../config.js";
import CustomerSatisfactionSurvey from "../CustomerSatisfactionSurvey";
import { NotificationContainer, NotificationManager } from "react-notifications";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";

const styles = StyleSheet.create({
	buttonContent: {
		display: "flex",
		flex: 1,
		alignItems: "center",
	},
	buttonText: {
		marginRight: 12,
		fontSize: 16,
		fontFamily: "freight-sans-pro",
		fontWeight: "light",
	},
	contentContainer: {
		paddingBottom: 140, // these values are based on the height of the footer
		[breakpoints.mobileOnly]: {
			paddingBottom: 240,
		},
	},
	exitButton: {
		backgroundColor: "transparent",
		border: "none",
		[breakpoints.mobileOnly]: {
			paddingTop: 12,
			paddingBottom: 12,
		},
	},
	header: {
		backgroundColor: colors.teal3,
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		color: colors.white,
		paddingLeft: 40,
		paddingRight: 40,
		[breakpoints.mobileOnly]: {
			paddingRight: 10,
			paddingLeft: 10,
		},
		"@media print": {
			display: "none",
		},
	},
	headerButton: {
		paddingLeft: 12,
		paddingRight: 12,
		border: "none",
		backgroundColor: "transparent",
	},
	headerButtonContainer: {
		display: "flex",
	},
	headerText: {
		fontFamily: "freight-sans-pro",
		fontSize: 18,
		lineHeight: 1.78,
		marginTop: 7,
		marginBottom: 9,
		color: colors.white,
		[breakpoints.mobileOnly]: {
			fontSize: 15,
			lineHeight: 2.13,
		},
	},
	languageButtonContainer: {
		paddingRight: 0,
	},
	languageButton: {
		backgroundColor: "transparent",
		border: "none",
		color: colors.white,
		fontFamily: "priori-sans",
		fontSize: 14,
		// fontWeight: "bold",
	},
	modalShowing: {
		maxHeight: "100vh",
		overflow: "hidden",
	},
	page: {
		minHeight: "100vh",
		position: "relative",
	},
	titleContainer: {
		textAlign: "center",
		marginBottom: 20,
		"@media print": {
			display: "none",
		},
	},
	title: {
		fontFamily: "priori-sans",
		fontSize: 32,
		fontWeight: "bold",
		lineHeight: 1,
		color: colors.black6,
		marginBottom: 15,
		[breakpoints.mobileOnly]: {
			marginBottom: 48,
		},
	},
});

export default class CustomerSatisfactionSurveyPage extends PureComponent {
	static propTypes = {
		certificate: PropTypes.string,
		params: PropTypes.object.isRequired,
		language: PropTypes.string.isRequired,
		pathname: PropTypes.string.isRequired,
		loggedIn: PropTypes.bool.isRequired,
		sessionId: PropTypes.string,
	};

	constructor(props) {
		super(props);

		this.strings = props.language === languages.es ? spanish : english;

		this.state = {
			classId: this.props.params.class_id,
			modalShowing: false,
		};
	}

	componentDidMount() {
		this._verifyClass();
	}

	_verifyClass = () => {
		getClass(this.state.classId)
			.then(course => {
				if (!course) {
					NotificationManager.error(this.strings.errors.failedToVerifyClass);
					this.setState({
						classId: null,
					});
				}
			})
			.catch(err => {
				if (err.response && err.response.status === 401) {
					browserHistory.push(
						`/login?redirectpath=${encodeURIComponent(
							`/survey/${this.state.classId}`,
						)}`,
					);
					window.location.reload();
				} else {
					NotificationManager.error(this.strings.errors.failedToVerifyClass);
					handleUnknownError(err);
					this.setState({
						classId: null,
					});
				}
			});
	};

	_setModalShowing = showing => {
		this.setState({
			modalShowing: showing,
		});
	};

	_toggleLanguage = () => {
		if (this.props.language === languages.es) {
			// redirect to english route
			browserHistory.push(`${this.props.pathname}?language=en`);
			window.location.reload();
		} else {
			// redirect to spanish route
			browserHistory.push(`${this.props.pathname}?language=es`);
			window.location.reload();
		}
	};

	render() {
		return (
			<div className={css([styles.page, this.state.modalShowing ? styles.modalShowing : ""])}>
				<a className="skip-main" href="#main">
					{this.strings.skipToContent}
				</a>
				<header className={css(styles.header)}>
					<div className={css(styles.headerText)}>
						{this.strings.keepingYourFamilyHealthy}
					</div>
					<div className={css(styles.languageButtonContainer)}>
						<button
							className={css(styles.languageButton)}
							onClick={this._toggleLanguage}
						>
							{this.strings.languageToggle}
						</button>
					</div>
				</header>
				<NotificationContainer />
				<div className={css(styles.contentContainer)} id="main">
					<Container>
						<Row>
							<div className={css(styles.titleContainer)}>
								<h1 className={css(styles.title)}>
									{this.strings.satisfactionSurvey}
								</h1>
								<img src={`${rootUrl}/images/survey-icon.png`} alt="Survey Icon" />
							</div>
						</Row>
						<Row>
							<Column>
								<CustomerSatisfactionSurvey
									classId={this.state.classId}
									language={this.props.language}
									certificate={this.props.certificate}
									loggedIn={this.props.loggedIn}
									setModalShowing={this._setModalShowing}
									sessionId={this.props.sessionId}
								/>
							</Column>
						</Row>
						<FooterRow language={this.props.language} />
					</Container>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/pages/CustomerSatisfactionSurveyPage.js